import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const TableCellStyled = styled.td<{
  $truncateText?: boolean;
  $width?: string;
  $maxWidth?: string;
  $showOverflow?: boolean;
  checkboxMargin?: boolean;
}>`
  ${(props) => textStyleCss(props.theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  border-bottom: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  padding: 10px 15px;
  height: 56px;
  ${(props) => props.$maxWidth && `max-width: ${props.$maxWidth};`}
  ${(props) => props.$width && `width: ${props.$width};`}
  vertical-align: middle;
  ${(props) => (props.$showOverflow ? `` : `overflow: hidden;`)}
  ${(props) =>
    props.$truncateText
      ? `
  white-space: nowrap;
  text-overflow: ellipsis;
  `
      : ''}
  ${(props) => (props.checkboxMargin ? 'padding-left: 20px;' : '')}
`;
